import { render, staticRenderFns } from "./add-coupon.vue?vue&type=template&id=fcc68e3a"
import script from "./add-coupon.vue?vue&type=script&lang=ts"
export * from "./add-coupon.vue?vue&type=script&lang=ts"
import style0 from "./add-coupon.vue?vue&type=style&index=0&id=fcc68e3a&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports